import { CanMatchFn } from '@angular/router';

import { ContactOnboardingDataService } from '../../modules/contact-onboarding/services/contact-onboarding-data.service';
import { createDataAccessGuard } from './data-access-guard.factory';

/**
 * Guards the contact-onboarding route:
 * - Sends already onboarded employees straight to Case Management.
 * - Redirects to login when there is no stored employee profile
 *   (e.g. the route was opened directly without authenticating first).
 */
export const ContactOnboardingGuard: CanMatchFn = createDataAccessGuard(
  ContactOnboardingDataService,
  (dataService) => dataService.hasEmployeeData(),
);
